import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/gift-pickup")({
  component: lazyRouteComponent(() => import("./-pages/admin.gift-pickup")),
  head: () => ({
    meta: [{ title: "استلام هدايا — Admin" }, { name: "robots", content: "noindex" }],
  }),
});
